import Core6Utilities from './Core6Utilities';
import Core6OptionsLogic from "./Core6OptionsLogic";

class Core6Page {
  initialise() {
    // //console.log('initialising page');

    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    });

    const pageSettingsBtn = Core6Utilities.getJQueryElement('#page_settings');
    pageSettingsBtn.on('click', () => {
      // console.log('Show modal');
      Core6Utilities.getJQueryElement('.pageSettingsModal').modal('show');
    });

    const savePageAsTemplateBtn = Core6Utilities.getJQueryElement('.saveAsTemplateBtn');
    savePageAsTemplateBtn.on('click', () => {
      // console.log('Show modal');
      Core6Utilities.getJQueryElement('.savePageAsTemplateModal').modal('show');
    });

    $(document.body).off('click', '[data-core6-page-action]', this.pageOptionsListener).on('click', '[data-core6-page-action]', this.pageOptionsListener);
    //$(document.body).on('change', '[data-core6-page-action]', this.pageOptionsListener);

    $(document.body).on(
      'click',
      '[data-core6-save-page-options]',
      (evt) => {
        const pageId = Core6Utilities.getJQueryElement('body[data-core6-page-id]').attr('data-core6-page-id');
        const pageOptions = Core6Utilities.getJQueryElement('.pageSettingsModal[data-page-id="' + pageId + '"] [data-core6-page-action]');
        console.log(pageOptions);
        Core6OptionsLogic.saveOptions(evt, pageOptions, 0, 0, pageId, 'page');
      },
    );
  }

  pageOptionsListener(evt) {
    const action = $(this).attr('data-core6-page-action');
    const pageId = Core6Utilities.getJQueryElement('body[data-core6-page-id]').attr('data-core6-page-id');
    const param = $(this).attr('data-core6-page-param');
    const value = $(this).attr('data-core6-page-value');
    const newTemplateId = $(this).val();

    switch (action) {
      case 'changePageColour':
        $('[data-core6-page-action="changePageColour"]').removeClass('selected');
        $(this).addClass('selected');
        //Core6Page.changePageAttribute(pageId, param, value);
        break;
      case 'changePageTemplate':
        //Core6Page.changePageTemplate(pageId, newTemplateId);
        break;
      case 'changePageTitle':
        //Core6Page.changePageTemplate(pageId, newTemplateId);
        break;
      case 'savePageAsTemplate':
        Core6Page.savePageAsTemplate(pageId, param);
        break;
      case 'savePageAsPage':
        Core6Page.savePageAsPage(pageId, param);
        break;
    }

    // console.log('preventDefault');
    evt.preventDefault();
  }

  static changePageTemplate(pageId, newTemplateId) {
    // TODO: Save page template here and reload iframe

  }

  static savePageAsTemplate(pageId, templateName) {
    let siteId = 0;
    if (document.getElementById('target_site_id') !== null && document.getElementById('target_site_id') !== undefined) {
      siteId = document.getElementById('target_site_id').value;
    }
    $.ajax({
      url: '/api/save_page_as_template',
      type: 'POST',
      data: {
        _method: 'POST', pageId, templateName, siteId,
      },
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        if ( confirm('Duplication Successful\n\nWould you like to visit the new template?') ) {
          window.location = data.editTemplateUrl;
        } else {
          window.location.reload(true);
        }
        //const previewFrame = document.getElementById('previewframe');
        //document.getElementById('page_url').value = data.editTemplateUrl;
        //previewFrame.setAttribute('src', data.editTemplateUrl);
      },
    });
  }

  static savePageAsPage(pageId, pageName) {
    let siteId = 0;
    if (document.getElementById('target_site_id') !== null && document.getElementById('target_site_id') !== undefined) {
      siteId = document.getElementById('target_site_id').value;
    }
    $.ajax({
      url: '/api/save_page_as_page',
      type: 'POST',
      data: {
        _method: 'POST', pageId, pageName, siteId,
      },
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        if ( confirm('Duplication Successful\n\nWould you like to visit the new page?') ) {
          window.location = data.editPageUrl;
        } else {
          window.location.reload(true);
        }
        //const previewFrame = document.getElementById('previewframe');
        //document.getElementById('page_url').value = data.editPageUrl;
        //previewFrame.setAttribute('src', data.editPageUrl);
      },
    });
  }

  static changePageAttributes(pageId, queue) {
    //console.log(queue);

    const paramData = {
      _method: 'POST',
      pageId,
      queue,
    };

    //console.log(paramData);

    $.ajax({
      url: `/api/save_page_attributes?_=${new Date().getTime()}`,
      type: 'POST',
      data: paramData,
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        //Core6Utilities.replaceComponentLoader(componentId, data);
        //Core6Utilities.replaceFullBlock(rowId, data);
        //Core6Utilities.getElement('.core_loading_anim_container').style.display = 'none';
        // TODO: reload entire page
        /*const d = new Date();
        location.reload(true);*/
        const currURL = window.location.href;
        window.location.href = currURL;
      },
    });
  }

  static changePageAttribute(pageId, param, value) {
    $.ajax({
      url: '/api/save_page_attribute',
      type: 'PATCH',
      data: {
        _method: 'PATCH', page_id: pageId, param, value,
      },
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        let i = 0;
        const json = JSON.parse(data);
        const jsonLength = json.length;

        for (i; i < jsonLength; i++) {
          switch (json[i].param) {
            case 'page_background_colour':
              document.getElementById('previewframe').contentWindow.document.body.classList.remove('primary_colour');
              document.getElementById('previewframe').contentWindow.document.body.classList.remove('secondary_colour');
              document.getElementById('previewframe').contentWindow.document.body.classList.remove('tertiary_colour');
              document.getElementById('previewframe').contentWindow.document.body.classList.remove('highlight_colour');
              document.getElementById('previewframe').contentWindow.document.body.classList.add(json[i].value);
              break;
          }
        }
      },
    });
  }
}

export default Core6Page;



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Page.js